import React from "react";
import closeIcon from "../../assets/img/icons/closeHamber.svg";
//import subtrac from "../../assets/img/icons/closeHamber.svg"
import logo from "../../assets/img/Logo/logo-menu.svg";
import home from "../../assets/img/icon-hambermenu/home-2.svg";
import plus from "../../assets/img/icon-hambermenu/add-square.svg";
import heart from "../../assets/img/icon-hambermenu/heart.svg";
import mytrip from "../../assets/img/icon-hambermenu/shopping-bag.svg";
import profile from "../../assets/img/icon-hambermenu/user.svg";
import wallete from "../../assets/img/icon-hambermenu/wallet-2.svg";
import { Link, useNavigate } from "react-router-dom";
import { useUserInfo } from "../../context/UserContext";
import { useAuth } from "../../context/authContext";

const HamberburgerMenu = ({close,setclose}) => {
  const {userinfo} = useUserInfo()
  const {token} = useAuth()
  const navigate = useNavigate();
  const goToCreate = () =>{
    if(token){
      
        if(userinfo.data.user.role === "ادمین" || userinfo.data.user.role === "میزبان" || userinfo.data.user.role === "سوپر ادمین" ){
          navigate("/create")} else {
          navigate("/hosting")
    
        }
      
      
    }else{
      navigate("/register")
    }
  }
  return (
    <div className={`HamberburgerMenu ${!close ? "HamberburgerMenu--close":"HamberburgerMenu--show"}`}>
      <div className="HamberburgerMenu--header">
        <img src={logo} />

        <img src={closeIcon} onClick={()=>setclose(false)} className="HamberburgerMenu--header-close" />
      </div>

      <p className="HamberburgerMenu--p mt-[34px]">دسترسی سریعتر</p>
      <div className="HamberburgerMenu--box">
        <img src={home} />
        <Link to="/">صفحه اصلی</Link>
      </div>
      <ul className="HamberburgerMenu-ul">
        <li>
          <img src={plus}/>
          <div className=" cursor-pointer" onClick={goToCreate} >افزودن اقامتگاه</div>
        </li>
        <li>
        <img src={heart}/>

          <Link to="/user/wishlist">علاقه مندی ها</Link>
        </li>
        <li>
        <img src={mytrip}/>

          <Link to="/user/mytrips">سفر های من</Link>
        </li>
        <li>
        <img src={profile}/>

          <Link to="/user/editprofile">پروفایل من</Link>
        </li>
        <li>
        <img src={wallete}/>

          <Link to="/wallet">کیف پول من</Link>
        </li>
      </ul>
      <hr />
      <div>
        <p className="HamberburgerMenu--p">پشتیبانی</p>
        <ul className="HamberburgerMenu--footer">
          <li> قوانین جاتیک</li>
          <li>راهنمای اجاره اقامتگاه</li>
          <li>راهنمای میزبانی در جاتیک</li>
          <li>سوالات متداول</li>
        </ul>
      </div>
    </div>
  );
};

export default HamberburgerMenu;
